import { defineComponent as _defineComponent } from 'vue'
import {computed, ref} from 'vue';
import PopupContainer from "@/components/popup.vue";
import useClickOutside from '@/composables/useClickOutside';
// import type { DataInstance } from "@busy-human/hxp-library";
import { Builders, Season, type DataInstance } from '@busy-human/hxp-library';
import { useShoppingBuilderStore } from '@/store/builder-shopping';
import { useAuth } from '@/store/auth';
import { useCartStore } from '@/store/cart';
import { useZohoStrings } from "@/store/zohoStrings";

import {useRoute} from 'vue-router';
import { useSeasons } from '@/store/seasons';
import { useSeasonFeature } from '@/composables/useSeasonFeature';
import emitter from '@/events';
import { useSeasonBuilders } from '@/store/builder-seasons';

type Emits = {
	(e: 'addBuilder'): void
	(e: 'editBuilder', builderId: string): void
}
type builderGroup = {
	teen?: string
	parent?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'new-builder-select',
  emits: ["addBuilder", "editBuilder"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const buildersEnabled = useSeasonFeature(Season.Features.BUILDERS);

const season = useSeasons();
const builderSeasons = useSeasonBuilders();
const builderStore = useShoppingBuilderStore();
const cartStore = useCartStore();
const auth = useAuth();
const route = useRoute();
const zohoStrings = useZohoStrings();

// type Props = {
// }
// const props = defineProps<Props>();

const emit = __emit;

const TitleHtml = computed(() => zohoStrings.strings?.zh_addTripsNoteTitle?.rendered || '');
const BodyHtml = computed(() => zohoStrings.strings?.zh_addTripsNoteTitle?.rendered || '');

const whatIsABuilderTitleHtml =     computed(() => zohoStrings.strings?.zh_whatIsABuilderTitle?.rendered || 'What is a Builder?');
const whatIsABuilderBodyHtml =      computed(() => zohoStrings.strings?.zh_whatIsABuilderDescription?.rendered || '');
const addTripsNoteTitleHtml =       computed(() => zohoStrings.strings?.zh_addTripsNoteTitle?.rendered || 'Add Trips you like to the cart');
const addTripsNoteBodyHtml =        computed(() => zohoStrings.strings?.zh_addTripsNoteDescription?.rendered || '');
const whyAddMultipleTitleHtml =     computed(() => zohoStrings.strings?.zh_whyAddMultipleNoteTitle?.rendered || 'Why add multiple trips?');
const whyAddMultipleBodyHtml =      computed(() => zohoStrings.strings?.zh_whyAddMultipleNoteDescription?.rendered || '');
const whyRankTripsTitleHtml =       computed(() => zohoStrings.strings?.zh_whyRankTripsNoteTitle?.rendered || 'Why Rank by Preference?');
const whyRankTripsBodyHtml =        computed(() => zohoStrings.strings?.zh_whyRankTripsNoteDescription?.rendered || '');
const whatIsTheLotteryTitleHtml =   computed(() => zohoStrings.strings?.zh_whatIsTheLotteryNoteTitle?.rendered || 'What is the HXP Lottery?');
const WhatIsTheLotteryBodyHtml =    computed(() => zohoStrings.strings?.zh_whatIsTheLotteryNoteDescription?.rendered || '');
const loginTitleHtml =              computed(() => zohoStrings.strings?.zh_loginTitle?.rendered || 'Log in to Save');
const loginBodyHtml =               computed(() => zohoStrings.strings?.zh_loginDescription?.rendered || '');
const whatIsWaitlistTitleHtml =     computed(() => zohoStrings.strings?.zh_whatIsWaitlistNoteTitle?.rendered || 'What is the waitlist?');
const whatIsWaitlistBodyHtml =      computed(() => zohoStrings.strings?.zh_whatIsWaitlistNoteDescription?.rendered || '');

const addBuilder = () => {
	emit('addBuilder');
};

const editBuilder = (builderId: string | undefined) => {
	if(builderId){
		emit('editBuilder', builderId);
	}
};

const showDropdown = ref(false);
const builderSelect = ref(null);
useClickOutside(builderSelect, ()=> {
	if(showDropdown.value){
		showDropdown.value = false;
	}
});


const selectableGroups = computed<builderGroup[]>(() => builderStore.selectableGroups);

const selectedGroup = computed<builderGroup | null>(() => builderStore.selectedGroup);

const selectedGroupTeen = computed(() => builderStore.builders?.[selectedGroup.value?.teen || ''] || null);
const selectedGroupParent = computed(() => builderStore.builders?.[selectedGroup.value?.parent || ''] || null);

const selectGroup = (group: builderGroup) => {
    if(group.teen){
	    builderStore.selectBuilder(group.teen);
	    showDropdown.value = false;
    }else if(group.parent){
	    builderStore.selectBuilder(group.parent);
	    showDropdown.value = false;
    }
};

const userHasTrips = computed(() => (cartStore.carts?.[cartStore.getCartId() || ''] || []).length > 0);




const __returned__ = { buildersEnabled, season, builderSeasons, builderStore, cartStore, auth, route, zohoStrings, emit, TitleHtml, BodyHtml, whatIsABuilderTitleHtml, whatIsABuilderBodyHtml, addTripsNoteTitleHtml, addTripsNoteBodyHtml, whyAddMultipleTitleHtml, whyAddMultipleBodyHtml, whyRankTripsTitleHtml, whyRankTripsBodyHtml, whatIsTheLotteryTitleHtml, WhatIsTheLotteryBodyHtml, loginTitleHtml, loginBodyHtml, whatIsWaitlistTitleHtml, whatIsWaitlistBodyHtml, addBuilder, editBuilder, showDropdown, builderSelect, selectableGroups, selectedGroup, selectedGroupTeen, selectedGroupParent, selectGroup, userHasTrips, computed, ref, PopupContainer, get useClickOutside() { return useClickOutside }, get Builders() { return Builders }, get Season() { return Season }, get useShoppingBuilderStore() { return useShoppingBuilderStore }, get useAuth() { return useAuth }, get useCartStore() { return useCartStore }, get useZohoStrings() { return useZohoStrings }, get useRoute() { return useRoute }, get useSeasons() { return useSeasons }, get useSeasonFeature() { return useSeasonFeature }, get emitter() { return emitter }, get useSeasonBuilders() { return useSeasonBuilders } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})